/**
 * @generated SignedSource<<95e4c5595e0878b3bd9e672f6c8d63a6>>
 * @relayHash d4ad6fff23b099908859f608b2b9ef90
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e689b0ef93e9cd90885cbd02f832f5f45dd27db789519ab338357d20667d96ef

import type { ConcreteRequest, Query } from 'relay-runtime';
export type SpaceSettingsFilterBarQuery$variables = {
  spaceKey?: string | null | undefined;
};
export type SpaceSettingsFilterBarQuery$data = {
  readonly space: {
    readonly alias: string | null | undefined;
    readonly currentUser: {
      readonly isAdmin: boolean;
    };
    readonly id: string | null | undefined;
    readonly key: string | null | undefined;
  } | null | undefined;
  readonly webItemSections: ReadonlyArray<{
    readonly cacheKey: string | null | undefined;
    readonly id: string | null | undefined;
    readonly items: ReadonlyArray<{
      readonly completeKey: string | null | undefined;
      readonly icon: {
        readonly path: string;
      } | null | undefined;
      readonly id: string | null | undefined;
      readonly label: string | null | undefined;
      readonly url: string | null | undefined;
    } | null | undefined>;
    readonly label: string | null | undefined;
  } | null | undefined> | null | undefined;
};
export type SpaceSettingsFilterBarQuery = {
  response: SpaceSettingsFilterBarQuery$data;
  variables: SpaceSettingsFilterBarQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "spaceKey"
  }
],
v1 = {
  "kind": "Variable",
  "name": "key",
  "variableName": "spaceKey"
},
v2 = {
  "kind": "ScalarField",
  "name": "id"
},
v3 = {
  "kind": "ScalarField",
  "name": "label"
},
v4 = [
  {
    "args": [
      (v1/*: any*/),
      {
        "kind": "Literal",
        "name": "location",
        "value": "system.space.tools"
      }
    ],
    "concreteType": "WebSection",
    "kind": "LinkedField",
    "name": "webItemSections",
    "plural": true,
    "selections": [
      (v2/*: any*/),
      (v3/*: any*/),
      {
        "kind": "ScalarField",
        "name": "cacheKey"
      },
      {
        "concreteType": "WebItem",
        "kind": "LinkedField",
        "name": "items",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "ScalarField",
            "name": "completeKey"
          },
          (v3/*: any*/),
          {
            "kind": "ScalarField",
            "name": "url"
          },
          {
            "concreteType": "Icon",
            "kind": "LinkedField",
            "name": "icon",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "path"
              }
            ]
          }
        ]
      }
    ]
  },
  {
    "args": [
      (v1/*: any*/)
    ],
    "concreteType": "Space",
    "kind": "LinkedField",
    "name": "space",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "alias"
      },
      (v2/*: any*/),
      {
        "kind": "ScalarField",
        "name": "key"
      },
      {
        "concreteType": "SpaceUserMetadata",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "isAdmin"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "SpaceSettingsFilterBarQuery",
    "selections": (v4/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SpaceSettingsFilterBarQuery",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "d4ad6fff23b099908859f608b2b9ef90",
    "id": "e689b0ef93e9cd90885cbd02f832f5f45dd27db789519ab338357d20667d96ef",
    "metadata": {},
    "name": "SpaceSettingsFilterBarQuery",
    "operationKind": "query",
    "text": "query SpaceSettingsFilterBarQuery($spaceKey:String){webItemSections(location:\"system.space.tools\",key:$spaceKey){id,label,cacheKey,items{id,completeKey,label,url,icon{path}}},space(key:$spaceKey){alias,id,key,currentUser{isAdmin}}}"
  }
};
})();

(node as any).hash = "bec7eccfcd875ecb2def1e08a955cdf3";

export default node;
